import { formatMoney } from 'utils'

import { type CostBreakdownItem } from './types'

interface CostBreakdownTableProps {
  items: CostBreakdownItem[]
}

function CostBreakdownTableHeader () {
  return (
    <thead>
      <tr className='bg-gray-100'>
        <th className='text-left py-2 px-2 body-sm rounded-tl-lg rounded-bl-lg'>Description</th>
        <th className='text-left py-2 px-2 body-sm'>Employees</th>
        <th className='text-left py-2 px-2 body-sm rounded-tr-lg rounded-br-lg'>Cost</th>
      </tr>
    </thead>
  )
}

interface CostBreakdownRowProps {
  item: CostBreakdownItem
}

function CostBreakdownRow ({ item }: CostBreakdownRowProps) {
  return (
    <tr>
      <td className='py-3 px-4'>
        <div className='body'>{item.title}</div>
        <div className='body-sm text-gray-500 mt-1'>
          {item.description}
        </div>
        {item.link && (
          <a href={item.link.href} className='body-sm text-purple-600 mt-1 block underline decoration-dotted'>
            {item.link.text}
          </a>
        )}
      </td>
      <td className='py-3 px-4'>
        <div className='body'>{item.employeeCount ?? '---'}</div>
        {item.perEmployeeAmount !== undefined && (
          <div className='body-sm text-gray-500 mt-1'>
            {formatMoney(item.perEmployeeAmount)} per employee
          </div>
        )}
      </td>
      <td className='py-3 px-4 body'>{item.amount}</td>
    </tr>
  )
}

export function CostBreakdownTable ({ items }: CostBreakdownTableProps) {
  return (
    <table className='hidden md:table w-full'>
      <CostBreakdownTableHeader />
      <tbody className='p-6'>
        {items.map((item, index) => (
          <CostBreakdownRow key={index} item={item} />
        ))}
      </tbody>
    </table>
  )
}

export type { CostBreakdownItem }
